import React from 'react';
import { motion } from 'framer-motion';
import { Truck } from 'lucide-react';
import './ProductsOverview.css';

const ProductsOverview = () => {
  const services = [
   
    {
      title: 'Freight Transport',
      text: 'We are experts in providing storage, packaging solutions and transport throughout the UK & Europe.',
      stats: ['24/7 Service', '500+ Routes'],
      link: '#freight',
    },
    {
      title: 'Removal Services',
      text: 'Every move and relocation managed by us is crafted with a forward-thinking approach and meticulous attention to detail. ',
      stats: ['24/7 Service', '500+ Routes'],
      link: '#freight',
    },
    {
      title: 'Specialized Haulage',
      text: 'Tailored solutions for oversized or sensitive cargo.',
      stats: ['Heavy Duty', 'Expert Handling'],
      link: '#haulage',
    },
    {
      title: 'Logistics Support',
      text: 'End-to-end supply chain management for your business.',
      stats: ['Custom Plans', '99% On-Time'],
      link: '#logistics',
    },
  ];

  // Animation variants for cards (simulate trucks driving in)
  const cardVariants = {
    hidden: { opacity: 0, x: -200 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, delay: i * 0.3, ease: 'easeOut' },
    }),
    hover: { scale: 1.05, transition: { duration: 0.3 } },
  };

  return (
    <section id="services" className="products-overview">
      <div className="highway-background" />
      <div className="road-lines" />
      <motion.h2
        className="products-title"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        viewport={{ once: true }}
      >
        Our Freight Solutions
      </motion.h2>
      <div className="services-roadway">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="service-card"
            custom={index}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            whileHover="hover"
            viewport={{ once: true }}
          >
            <Truck className="service-truck" size={60} />
            <div className="service-content">
              <h3 className="service-title">{service.title}</h3>
              <p className="service-text">{service.text}</p>
              <div className="service-stats">
                {service.stats.map((stat, idx) => (
                  <span key={idx} className="stat-item">{stat}</span>
                ))}
              </div>
              <motion.a
                href={service.link}
                className="service-link"
                whileHover={{ x: 10 }}
                transition={{ duration: 0.3 }}
              >
                Explore More
              </motion.a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ProductsOverview;